import { render, staticRenderFns } from "./DashboardSelector.vue?vue&type=template&id=4a186987"
import script from "./DashboardSelector.vue?vue&type=script&lang=js"
export * from "./DashboardSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports